export default __webpack_public_path__ + "static/media/ChitPro_2021_logo_sm.4438d412.svg";